import { useCallback, useEffect, useState } from 'react';
import '../Styles/distributor-root.css';
import {
    Outlet,
    Link,
    useNavigate,
    useLocation,
} from "react-router-dom";
    

const data = [
    {path:'/dashboard', title:'Dashboard', icon:<svg class="w-5 h-5 text-amber-500 transition duration-75 dark:text-amber-400 group-hover:text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15v4m6-6v6m6-4v4m6-6v6M3 11l6-5 6 5 5.5-5.5"/> </svg>},
    {path:'/artists', title:'Artistas', icon:<svg class="w-5 h-5 text-amber-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/> </svg>},
    {path:'/albums', title:'Álbuns', icon: <svg class="w-5 h-5 text-amber-500 transition duration-75 dark:text-amber-400 group-hover:text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/> </svg>},
    {path:'/playlists', title:'Playlists', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm0 0-4 4m5 0H4m1 0 4-4m1 4 4-4m-4 7v6l4-3-4-3Z"/> </svg> },
    {path:'/merge-singles', title:'Agrupar em álbum', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12l4-4m-4 4 4 4m10-8-4 4m4-4-4-4"/> </svg>},
    {path:'/releases', title:'Carregar Álbum / EP', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/> </svg> },
    {path:'/sales-report', title:'Vendas de álbuns', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15v4m6-6v6m6-4v4m6-6v6M3 11l6-5 6 5 5.5-5.5"/> </svg> },
    {path:'/royalties', title:'Royalties de streaming', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"/> </svg> },
    {path:'/payouts', title:'Pagamentos', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1M3 18v-7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/> </svg> },
    {path:'/upload', title:'Carregar single', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1M9 12H4m8 8V9h8v11h-8Zm0 0H9m8-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"/> </svg> },
    {path:'/settings', title:'Definições', icon: <svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 5 9 4V3m5 2 1-1V3m-3 6v11m0-11a5 5 0 0 1 5 5m-5-5a5 5 0 0 0-5 5m5-5a4.959 4.959 0 0 1 2.973 1H15V8a3 3 0 0 0-6 0v2h.027A4.959 4.959 0 0 1 12 9Zm-5 5H5m2 0v2a5 5 0 0 0 10 0v-2m2.025 0H17m-9.975 4H6a1 1 0 0 0-1 1v2m12-3h1.025a1 1 0 0 1 1 1v2M16 11h1a1 1 0 0 0 1-1V8m-9.975 3H7a1 1 0 0 1-1-1V8"/> </svg> },
    {path:'/podcasters', title:'Podcasters', icon:<svg class="w-5 h-5 text-amber-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"> <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/> </svg>},
    {path:'/podcasts', title:'Carregar podcast', icon:<svg class="w-5 h-5 text-amber-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
      </svg>
      }, ];

const byPath = Object.fromEntries(data.map(e => [e.path, e]));

// Sidebar grouped by subject. A group with a single path renders as a plain link.
const menu = [
    {key:'dashboard', paths:['/dashboard']},
    {key:'artists', paths:['/artists']},
    {key:'music', title:'Música', paths:['/releases', '/upload', '/playlists']},
    {key:'podcasts', title:'Podcasts', paths:['/podcasters', '/podcasts']},
    {key:'sales', title:'Financeiro', paths:['/sales-report', '/royalties', '/payouts']},
    {key:'settings', paths:['/settings']},
].map(g => ({...g, items: g.paths.map(p => byPath[p])}));

const OPEN_GROUPS_KEY = 'distributor_menu_open_groups';
// Height of the "A ver como" banner shown while an admin impersonates.
const BANNER_HEIGHT = 42;

// Detail pages live under a different prefix than their list (/release/12 vs
// /releases); these keep the list's menu item highlighted on them.
const ACTIVE_ALIASES = {
    '/releases': ['/release/', '/merge-singles'],
    '/playlists': ['/playlist/'],
    '/artists': ['/artist/'],
    '/podcasters': ['/podcaster/'],
};

function isActive(path, pathname){
    if (pathname === path || pathname.startsWith(path + '/')) return true;
    return (ACTIVE_ALIASES[path] || []).some(prefix => pathname.startsWith(prefix));
}

function readOpenGroups(){
    try { return JSON.parse(localStorage.getItem(OPEN_GROUPS_KEY)) || []; }
    catch { return []; }
}

function MenuLink({item, active, nested}){
    return (
        <Link to={item.path}>
            <span className={`flex items-center px-2 rounded-lg group ${nested ? 'ps-9 py-1.5 text-sm' : 'py-2'} ${active ? 'bg-white/10' : 'hover:bg-white/5'}`}>
                {!nested && item.icon}
                <span className={`${nested ? '' : 'ms-3'} ${active ? 'text-amber-400' : 'text-gray-100'}`}>{item.title}</span>
            </span>
        </Link>
    );
}

    export default function DistributorRoot(){
        const navigate = useNavigate();

        const { pathname } = useLocation();
        const [openGroups, setOpenGroups] = useState(readOpenGroups);
        const [drawerOpen, setDrawerOpen] = useState(false);

        // Keep the group of the current page open; close the mobile drawer on navigation.
        useEffect(() => {
            setDrawerOpen(false);
            const current = menu.find(g => g.items.length > 1 && g.items.some(e => isActive(e.path, pathname)));
            if (current) setOpenGroups(prev => prev.includes(current.key) ? prev : [...prev, current.key]);
        }, [pathname]);

        useEffect(() => {
            try { localStorage.setItem(OPEN_GROUPS_KEY, JSON.stringify(openGroups)); } catch {}
        }, [openGroups]);

        const toggleGroup = key => setOpenGroups(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);

        const isImpersonating = localStorage.getItem('impersonating') === 'true';
        const top = isImpersonating ? BANNER_HEIGHT : 0;
        const impersonatingName = localStorage.getItem('impersonating_name') || '';

        const stopImpersonation = useCallback(() => {
            const backupToken = localStorage.getItem('admin_backup_token');
            const backupType = localStorage.getItem('admin_backup_type');
            const backupId = localStorage.getItem('admin_backup_id');
            const backupName = localStorage.getItem('admin_backup_name');
            const backupUser = localStorage.getItem('admin_backup_user');

            if (backupToken && backupType) {
                localStorage.setItem('token', backupToken);
                localStorage.setItem('type', backupType);
                localStorage.setItem('id', backupId);
                localStorage.setItem('name', backupName);
                localStorage.setItem('user', backupUser);
            }

            localStorage.removeItem('admin_backup_token');
            localStorage.removeItem('admin_backup_type');
            localStorage.removeItem('admin_backup_id');
            localStorage.removeItem('admin_backup_name');
            localStorage.removeItem('admin_backup_user');
            localStorage.removeItem('impersonating');
            localStorage.removeItem('impersonating_name');

            window.location.href = '/distributors';
        });

        const handleLogout = useCallback(()=>{
            localStorage.clear();
           navigate("/");
           window.location.reload();

        });

        return (
            <>
                {isImpersonating && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        backgroundColor: '#f59e0b',
                        color: '#1c0c32',
                        height: BANNER_HEIGHT,
                        padding: '0 12px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 12,
                        fontSize: 14,
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>A ver como: <strong>{impersonatingName}</strong></span>
                        <button
                            onClick={stopImpersonation}
                            style={{
                                backgroundColor: '#1c0c32',
                                color: '#f59e0b',
                                border: 'none',
                                borderRadius: 6,
                                padding: '4px 14px',
                                fontSize: 13,
                                fontWeight: 700,
                                cursor: 'pointer',
                                flexShrink: 0,
                            }}
                        >
                            Voltar ao Admin
                        </button>
                    </div>
                )}
                <header className="sm:hidden fixed inset-x-0 z-30 h-14 flex items-center gap-3 px-4" style={{ top, backgroundColor: '#1c0c32' }}>
                    <button type="button" onClick={() => setDrawerOpen(true)} aria-label="Abrir menu" aria-controls="default-sidebar" aria-expanded={drawerOpen}
                        className="p-2 -ms-2 rounded-lg text-gray-100 hover:bg-white/10">
                        <svg className="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M5 7h14M5 12h14M5 17h14"/></svg>
                    </button>
                    <span className="text-gray-100 font-semibold">Izenu Distribuidor</span>
                </header>

                {drawerOpen && (
                    <div className="sm:hidden fixed inset-0 z-30 bg-black/50" onClick={() => setDrawerOpen(false)} aria-hidden="true"/>
                )}

                <aside id="default-sidebar" className={`fixed left-0 z-40 w-64 transition-transform sm:translate-x-0 ${drawerOpen ? 'translate-x-0' : '-translate-x-full'}`}
                    style={{ top, height: `calc(100vh - ${top}px)` }} aria-label="Sidebar">
                    <div className="h-full px-3 py-4 overflow-y-auto" style={{ backgroundColor: '#1c0c32' }}>
                        <ul className="space-y-1 font-medium [&_li]:!p-0">
                        {menu.map(g => {
                            if (g.items.length === 1) {
                                const item = g.items[0];
                                return (<li key={g.key}><MenuLink item={item} active={isActive(item.path, pathname)}/></li>);
                            }
                            const open = openGroups.includes(g.key);
                            const hasActive = g.items.some(e => isActive(e.path, pathname));
                            return (
                                <li key={g.key}>
                                    <button type="button" onClick={() => toggleGroup(g.key)} aria-expanded={open}
                                        className="flex w-full items-center px-2 py-2 rounded-lg hover:bg-white/5 group">
                                        {g.items[0].icon}
                                        <span className={`ms-3 flex-1 text-left ${hasActive ? 'text-amber-400' : 'text-gray-100'}`}>{g.title}</span>
                                        <svg className={`w-3 h-3 text-gray-400 transition-transform ${open ? 'rotate-90' : ''}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="m9 5 7 7-7 7"/></svg>
                                    </button>
                                    {open && (
                                        <ul>
                                            {g.items.map(e => (
                                                <li key={e.path}><MenuLink item={e} active={isActive(e.path, pathname)} nested/></li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            );
                        })}
                        <li aria-hidden="true">
                            <hr className="my-3 border-t border-white/20" />
                        </li>
                        <li>
                            <button onClick={()=>handleLogout()} className="flex items-center px-2 py-2 rounded-lg hover:bg-white/5 group">
                                <span className="ms-3 text-amber-500">Sair</span>
                            </button>
                        </li>
                        </ul>
                    </div>
                </aside>

                {/* No scroll container of its own: .App (100vh) is the one that
                    scrolls. A second one here, offset by the banner, gave pages
                    two or three scrollbars and broke sticky bars. */}
                <div className="sm:ml-64" style={isImpersonating ? { paddingTop: BANNER_HEIGHT } : {}}>
                    <div className="pt-14 sm:pt-0">
                        <Outlet/>
                    </div>
                </div>
            </>
        );


    }